import http from '../../services/http';
import { setBooks } from '../entities/books';
import { setBook, setChapters } from '../entities/book';
import { setBookLoader } from '../ui/loaders';

const path = 'api/book';
const path2 = 'api/teacherassistant';

const all = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const token = store.auth.token;
      const res = await http.get({
        url: path + `${token ? '/my_books' : '/allbooks'}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      dispatch(setBooks(res.data.data));
      // if (res.data.data.length > 0) dispatch(setBook(res.data.data[0]));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const show = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    dispatch(setBookLoader(true));
    try {
      const res = await http.get({
        url: path + `/${id}`,
        headers: {},
      });

      dispatch(setChapters(res.data.data));
      dispatch(setBookLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      dispatch(setBookLoader(false));
      if (onError) onError(error);
    } finally {
      dispatch(setBookLoader(false));
      if (onEnd) onEnd();
    }
  };
};

const single = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    const store = getState();
    const token = store.auth.token;
    try {
      const res = await http.get({
        url: path + `/show/${id}`,
        headers: {
          'x-auth-token': token,
        },
      });
      dispatch(setBook(res?.data?.data?.book || {}));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const getBookByID = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    const store = getState();
    const token = store.auth.token;
    try {
      const res = await http.get({
        url: path2 + `/specificbook/${id}`,
        headers: {
          'x-auth-token': token,
        },
      });
      if (onSuccess) onSuccess(res?.data);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const professorBooks = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    const store = getState();
    const token = store.auth.token;
    try {
      const res = await http.get({
        url: path + `/my_books`,
        headers: {
          'x-auth-token': token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const upload = ({ onSuccess, onError, body, onEnd }) => {
  return async (dispatch, getState) => {
    const store = getState();
    const token = store.auth.token;
    try {
      const res = await http.post({
        url: path + `/uploads3book`,
        body,
        headers: {
          'x-auth-token': token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const create = ({ onSuccess, onError, body, onEnd }) => {
  return async (dispatch, getState) => {
    const store = getState();
    const token = store.auth.token;
    try {
      const res = await http.post({
        url: path + `/uploads3urlfile`,
        body,
        headers: {
          'x-auth-token': token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const getBooksList = ({ onSuccess, onError, onEnd, body }) => {
  return async (_, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path2 + '/classes',
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res?.data);
    } catch (error) {
      onError?.(error);
    } finally {
      onEnd?.();
    }
  };
};

const addBookToClass = ({ onSuccess, onError, onEnd, body }) => {
  return async (_, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path2 + '/change-book',
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res?.data);
    } catch (error) {
      onError?.(error);
    } finally {
      onEnd?.();
    }
  };
};

const updateBookStatus = ({ onSuccess, onError, onEnd, body, id = '', status = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path2 + `/changestatus/${id}?bookstatus=${status}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res?.data);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const updateBookDetails = ({ onSuccess, onError, onEnd, body, id }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path2 + `/updatebookdetails/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res?.data);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const deleteBookById = ({ onSuccess, onError, onEnd, bookId, status }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.delete({
        url: path2 + `/book?id=${bookId}&status=${status}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      onSuccess?.(res?.data);
    } catch (error) {
      onError?.(error);
    } finally {
      onEnd?.();
    }
  };
};

const replaceBook = ({ onSuccess, onError, onEnd, oldBookId, newBookId }) => {
  return async (_, getState) => {
    try {
      const store = getState();
      const res = await http.delete({
        url: path2 + `/book-association?oldBookId=${oldBookId}&newBookId=${newBookId}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      onSuccess?.(res?.data);
    } catch (error) {
      onError?.(error);
    } finally {
      onEnd?.();
    }
  };
};

export { all, show, upload, single, create, replaceBook, getBookByID, getBooksList, professorBooks, deleteBookById, addBookToClass, updateBookStatus, updateBookDetails };
